import styled from "styled-components"
import media from "src/styles/media"
import Img from "gatsby-image"
import Link from "src/components/util/TransitionLink"

export const ProjectWrapper = styled.div`
  padding: 20px 0;
  max-width: 48rem;
  margin: 0 auto;

  ${media.lessThan("md")`
    max-width: 90%;
  `}
`

export const ProjectLinkBack = styled(Link)`
  display: block;
  font-size: 17px;
  margin-bottom: 50px;
  color: var(--primary);
  font-weight: 600;

  &:hover {
    color: var(--primary);
  }

  ${media.lessThan("lg")`
      margin-bottom: 45px;
  `}
`

export const ProjectText = styled.div`
  padding: 40px 4%;

  ${media.lessThan("md")`
    padding: 20px 0;
  `}
`

export const ProjectInfoItem = styled.div`
  font-weight: 600;
  font-size: 19px;
  color: #0a1431;
  margin-bottom: 15px;

  span {
    display: block;
    font-weight: 400;
  }

  ${media.lessThan("md")`
    font-size: 18px;

    span{
      display: inline-block;
      margin-left: 5px;
    }
  `}
`

export const ProjectLink = styled.a`
  display: block;
  font-size: 23px;
  text-decoration: underline !important;
  color: var(--dark) !important;
  text-align: center;
  width: 100%;
  margin-bottom: 25px;
  letter-spacing: 1.5px;
  transition: color 0.4s;

  &:hover {
    color: var(--primary) !important;
  }

  ${media.lessThan("md")`
    font-size: 19px;
    padding: 0 4%;
  `}
`

export const ProjectTitle = styled.h1`
  font-weight: 600;
  font-size: 37px;
  font-weight: 700;
  margin-bottom: 5px;
  color: #0a1431;

  ${media.lessThan("lg")`
    font-size: 1.6rem;
    line-height: 1.1;
    margin-bottom: 12px;
  `}
`

export const ProjectDescription = styled.p`
  font-size: 19px;
  font-weight: 200;
  color: #130737;

  ${media.lessThan("lg")`
    font-size: 17px;
    line-height: 1.3;
    margin-bottom: 20px;
  `}
`

export const ProjectDivisor = styled(Img)`
  width: 55px;
  margin: 30px auto;

  ${media.lessThan("md")`
        width: 45px;
        margin: 30px auto 10px auto;
    `}
`
